import {ActionStatusType, ActionType, ApplicationType, SortDirection} from "../../../common/enums/enums";
import {HttpParams} from "@angular/common/http";


export class ActionsQuery  implements ActionsQueryContract {
    public readonly application = ApplicationType.BUILDING; // Used
    public actionIds?: string[]; // Used
    public buildingGuids?: string[]; // Used
    public urgentOnly = false;
    public dueDate?: Date; // Used
    public statuses?: ActionStatusType[]; // Used
    public locationStructureId?: number; // Used
    public interventionTeams?: string[]; // Used
    public sortBy = SortDirection.DESC; // Used
    public issueGuid?: string; // Used
    public type?: ActionType; // Used
    public createdFrom?: Date;
    public createdTo?: Date;
    public executedBefore?: Date;
    public executedAfter?: Date; // Used
    public searchPhrase?: string; // Used
    public unassignedOnly?: boolean;
    
    public set selectionPeriodInMonths(months: SelectionPeriodInMonths) {
        this.executedAfter = new Date();
        this.executedAfter.setMonth(this.executedAfter.getMonth() - +months);
        this.executedAfter.setHours(0, 0, 0, 0);
    }
    
    public static with(predicates: Partial<ActionsQueryContract>) {
        const instance = new ActionsQuery();
        return Object.assign(instance, predicates);
    }

    public params(): HttpParams {
        const propertyMap = Object.keys(this).reduce(
            (collection, property) => {
                collection[property] = convert(this[property]);
                return collection;
            },
            {}
        );
        return new HttpParams({fromObject: propertyMap});
    }
}
interface ActionsQueryContract {
    application: ApplicationType;
    actionIds?: string[];
    buildingGuids?: string[];
    urgentOnly: boolean;
    dueDate?: Date;
    statuses?: ActionStatusType[];
    locationStructureId?: number;
    interventionTeams?: string[];
    sortBy: SortDirection;
    issueGuid?: string;
    type?: ActionType;
    createdFrom?: Date;
    createdTo?: Date;
    executedBefore?: Date;
    executedAfter?: Date;
    searchPhrase?: string;
    unassignedOnly?: boolean;
}

export type SelectionPeriodInMonths = 3 | 6 | 9;

function convert(param: any) {
    return param instanceof Date ? param.toISOString().split('T')[0] : param;
}